var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSale1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sale 1",
    clipPath: "url(#clip0_3266_766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.1208 18.8359L38.2571 15.8708C38.036 15.6427 37.9306 15.3192 37.9753 15.0048L38.5502 10.9243C38.7865 9.25106 37.667 7.71273 36.004 7.42168L31.9447 6.70982C31.6314 6.65502 31.3556 6.45429 31.2075 6.17235L29.2788 2.53393C28.4868 1.03924 26.6757 0.451078 25.1566 1.19535L21.4564 3.00643C21.1704 3.14638 20.8297 3.14638 20.5437 3.00643L16.8434 1.19535C15.3234 0.450996 13.5143 1.03916 12.7213 2.53393L10.7926 6.17235C10.6424 6.45831 10.3727 6.65305 10.0554 6.70982L5.9971 7.42168C4.33301 7.71166 3.21452 9.25106 3.45077 10.9232L4.02474 15.0047C4.06937 15.3232 3.96797 15.6395 3.74288 15.8707L0.87917 18.8358C-0.293057 20.0487 -0.293057 21.951 0.87917 23.1638L3.74288 26.1289C3.96395 26.357 4.06937 26.6806 4.02474 26.9949L3.44978 31.0755C3.21353 32.7487 4.33301 34.287 5.99603 34.578L10.0553 35.2899C10.3686 35.3447 10.6444 35.5454 10.7925 35.8274L12.7212 39.4658C13.5142 40.9605 15.3243 41.5487 16.8434 40.8044L20.5436 38.9933C20.8296 38.8534 21.1703 38.8534 21.4563 38.9933L25.1566 40.8044C25.6017 41.0224 26.0712 41.1259 26.5336 41.1259C27.6491 41.1259 28.7189 40.5225 29.2786 39.4659L31.2074 35.8275C31.3575 35.5415 31.6272 35.3468 31.9446 35.29L36.0028 34.5781C37.6669 34.2882 38.7854 32.7488 38.5491 31.0766L37.9751 26.9951C37.9305 26.6766 38.0319 26.3603 38.257 26.1291L41.1207 23.164C42.2931 21.9511 42.2931 20.0488 41.1208 18.8359ZM39.6271 21.7219L36.7634 24.6849C36.0911 25.3805 35.7839 26.3277 35.9187 27.285L36.4927 31.3655C36.5718 31.9233 36.1986 32.4364 35.645 32.5337L31.5847 33.2456C30.6315 33.413 29.8253 34.0001 29.3721 34.8549L27.4433 38.4923C27.1797 38.9912 26.5773 39.188 26.0693 38.9396L22.3691 37.1274C21.9411 36.9186 21.4706 36.8131 21.0001 36.8131C20.5297 36.8131 20.0591 36.9186 19.6312 37.1284L15.9309 38.9385C15.4249 39.188 14.8205 38.9912 14.5569 38.4923L12.6282 34.8539C12.1749 33.9981 11.3677 33.412 10.4135 33.2456L6.35525 32.5328C5.80162 32.4354 5.42838 31.9234 5.50647 31.3655L6.08143 27.285C6.21629 26.3277 5.909 25.3806 5.23774 24.686L2.37304 21.7219C1.98265 21.3162 1.98265 20.6835 2.37304 20.2779L5.23675 17.3148C5.90908 16.6192 6.21629 15.6721 6.08143 14.7148L5.50746 10.6342C5.42838 10.0765 5.80154 9.56336 6.35517 9.46599L10.4155 8.75412C11.3687 8.58677 12.1749 7.99968 12.6281 7.14483L14.5568 3.5074C14.8205 3.00848 15.4249 2.81382 15.9308 3.06016L19.6311 4.87232C20.4869 5.2901 21.5131 5.29109 22.3691 4.87133L26.0693 3.06131C26.5764 2.81186 27.1797 3.00857 27.4433 3.50748L29.3721 7.1459C29.8254 8.00173 30.6326 8.58792 31.5867 8.7542L35.645 9.46705C36.1986 9.56442 36.5719 10.0765 36.4938 10.6343L35.9188 14.7148C35.784 15.6721 36.0912 16.6192 36.7625 17.3138L39.6272 20.2779C40.0176 20.6835 40.0176 21.3163 39.6271 21.7219Z",
    fill: "url(#paint0_linear_3266_766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.9647 14.0354C27.5591 13.6298 26.902 13.6298 26.4964 14.0354L14.0357 26.4961C13.63 26.9018 13.63 27.5589 14.0357 27.9645C14.2385 28.1673 14.5042 28.2688 14.7699 28.2688C15.0356 28.2688 15.3013 28.1674 15.504 27.9645L27.9647 15.5038C28.3703 15.0981 28.3703 14.4411 27.9647 14.0354Z",
    fill: "url(#paint1_linear_3266_766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9655 15.8099C19.9655 13.5181 18.1017 11.6543 15.8099 11.6543C13.5181 11.6543 11.6543 13.5181 11.6543 15.8099C11.6543 18.1017 13.5181 19.9655 15.8099 19.9655C18.1017 19.9655 19.9655 18.1017 19.9655 15.8099ZM13.7312 15.8099C13.7312 14.664 14.6641 13.7311 15.81 13.7311C16.9559 13.7311 17.8888 14.664 17.8888 15.8099C17.8888 16.9558 16.9559 17.8888 15.81 17.8888C14.664 17.8888 13.7312 16.9558 13.7312 15.8099Z",
    fill: "url(#paint2_linear_3266_766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.1898 22.0342C23.898 22.0342 22.0342 23.898 22.0342 26.1898C22.0342 28.4816 23.898 30.3454 26.1898 30.3454C28.4816 30.3454 30.3454 28.4816 30.3454 26.1898C30.3454 23.898 28.4816 22.0342 26.1898 22.0342ZM26.1898 28.2686C25.0439 28.2686 24.111 27.3356 24.111 26.1897C24.111 25.0438 25.0439 24.1109 26.1898 24.1109C27.3357 24.1109 28.2686 25.0438 28.2686 26.1897C28.2686 27.3356 27.3357 28.2686 26.1898 28.2686Z",
    fill: "url(#paint3_linear_3266_766)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3266_766",
    x1: 21,
    y1: 0.873535,
    x2: 21,
    y2: 41.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF211C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3266_766",
    x1: 21.0002,
    y1: 13.7312,
    x2: 21.0002,
    y2: 28.2688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF211C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3266_766",
    x1: 15.8099,
    y1: 11.6543,
    x2: 15.8099,
    y2: 19.9655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF211C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3266_766",
    x1: 26.1898,
    y1: 22.0342,
    x2: 26.1898,
    y2: 30.3454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF211C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3266_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale1);
export default __webpack_public_path__ + "static/media/sale 1.46f56c45fd76ff3667b7cca375235234.svg";
export { ForwardRef as ReactComponent };